var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuCadastros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.491,
    height: 28.49,
    viewBox: "0 0 28.491 28.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu-cadastros",
    d: "M5.342,1.187h6.547a6.59,6.59,0,0,1,1.169.1V7.716a2.972,2.972,0,0,0,2.968,2.968H22.45a6.09,6.09,0,0,1,.084.642.6.6,0,0,0,.64.544.594.594,0,0,0,.544-.64A7.719,7.719,0,0,0,21.482,6.4L17.345,2.261A7.665,7.665,0,0,0,11.889,0H5.342A5.347,5.347,0,0,0,0,5.342V23.149a5.349,5.349,0,0,0,5.342,5.342H10.09a.594.594,0,1,0,0-1.187H5.342a4.159,4.159,0,0,1-4.155-4.155V5.342A4.159,4.159,0,0,1,5.342,1.187Zm15.3,6.05A6.54,6.54,0,0,1,22.115,9.5H16.026a1.783,1.783,0,0,1-1.781-1.781V1.624A6.514,6.514,0,0,1,16.506,3.1l4.137,4.137Zm6.978,6.691a3.039,3.039,0,0,0-4.2,0l-9.149,9.149a4.128,4.128,0,0,0-1.217,2.938V27.9a.594.594,0,0,0,.594.594h1.883a4.128,4.128,0,0,0,2.938-1.217l9.149-9.149a2.969,2.969,0,0,0,0-4.2Zm-.839,3.357-9.149,9.149a2.949,2.949,0,0,1-2.1.869H14.244V26.013a2.951,2.951,0,0,1,.869-2.1l9.149-9.149a1.825,1.825,0,0,1,2.518,0,1.783,1.783,0,0,1,0,2.519Z",
    transform: "translate(0 -0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCadastros);
export default __webpack_public_path__ + "static/media/menu-cadastros.305b87ffba9ade6952967b3e2f395698.svg";
export { ForwardRef as ReactComponent };